import { render } from "./PC.vue?vue&type=template&id=a08adbb8&bindings={}"
import script from "./PC.vue?vue&type=script&lang=js"
export * from "./PC.vue?vue&type=script&lang=js"

import "./PC.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script